<div class="apps-grid-container p-16" (click)="onTileClick()">
  <div class="tiles-wrapper">
    <div class="tools-group">
      @for(tile of toolTiles; track tile.title) {
        <div class="tile-container small-tile">
          <app-tile [icon]="tile.icon" [color]="tile.color" [title]="tile.title" [subtitle]="tile.subtitle"
            [link]="tile.link" [isSmall]="true">
          </app-tile>
        </div>
      }
    </div>

    <div class="main-tiles-group">
      @for(tile of mainTiles; track tile.title) {
        <div class="tile-container">
          <app-tile
            [icon]="tile.icon"
            [color]="tile.color"
            [title]="tile.title"
            [subtitle]="tile.subtitle"
            [link]="tile.link || ''"
            [action]="tile.action || ''"
            (actionTriggered)="onTileAction(tile)">
          </app-tile>
        </div>
      }
    </div>
  </div>
</div>